import { ApiMetric } from "@incendium/api";
import { useMetricLabels } from "features/analytics/hooks/useMetricLabels";
import { camelToText } from "Helpers/camelToText";
import { useCallback } from "react";

export const useMetricName = () => {
  const { allMetricLabels } = useMetricLabels();

  return useCallback(
    (metric: ApiMetric) => {
      const found = allMetricLabels.find((ml) => ml.metric === metric);
      return found?.label
        ? found.label
        : camelToText(metric.replace("Metric", ""));
    },
    [allMetricLabels]
  );
};
